import { createSlice } from '@reduxjs/toolkit';
import { apiGet } from 'src/lib/api/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  tutorials: [],
  selectedTutorial: null
};

const slice = createSlice({
  name: 'tutorials',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TUTORIALS
    getTutorialsSuccess(state, action) {
      state.isLoading = false;
      state.tutorials = action.payload;
    },

    // GET TUTORIAL DETAIL
    getTutorialDetailSuccess(state, action) {
      state.isLoading = false;
      state.selectedTutorial = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { startLoading, hasError, getTutorialsSuccess, getTutorialDetailSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getTutorials() {
  return async (dispatch) => {
    dispatch(startLoading());
    try {
      const response = await apiGet('/tutorials', {
        meta: {
          globalError: false, // Handle locally
          context: 'tutorials-list'
        }
      });
      dispatch(getTutorialsSuccess(response.data));
    } catch {
      dispatch(
        hasError(
          'There has been an error loading the tutorials, please try to refresh. If the error persists please contact support@complimind.co.uk'
        )
      );
    }
  };
}

export function getTutorialDetail(slug) {
  return async (dispatch) => {
    dispatch(startLoading());
    try {
      const response = await apiGet(`/tutorials/${slug}`, {
        meta: {
          globalError: false, // Handle locally
          context: 'tutorial-detail'
        }
      });
      dispatch(getTutorialDetailSuccess(response.data));
    } catch {
      dispatch(
        hasError(
          'There has been an error loading the tutorial details, please try to refresh. If the error persists please contact support@complimind.co.uk'
        )
      );
    }
  };
}
